import { Link } from 'react-router-dom';
import { styled } from '@mui/material';

import { DESKTOP_MIN_WIDTH, TABLET_MIN_WIDTH } from '~/constants/common';
import { COLORS } from '~/styles/colors';

export const StyledViewAll = styled(Link)(({ theme }) => {
  return {
    marginInline: 'auto',
    textDecoration: 'none',
    fontSize: '18px',
    fontWeight: 500,
    lineHeight: '24px',
    borderRadius: '100px',
    color: COLORS.white,
    background: 'linear-gradient(90deg, #0487E6 0%, #46A4E8 100%)',
    padding: '12px 40px',
    marginTop: '60px',
    [theme.breakpoints.down(DESKTOP_MIN_WIDTH)]: {
      marginTop: '40px',
    },
    [theme.breakpoints.down(TABLET_MIN_WIDTH)]: {
      marginTop: '20px',
    },
    '&:hover': {
      opacity: 0.9,
    },
  };
});

export const StyledContainer = styled('div')(({ theme }) => {
  return {
    display: 'flex',
    flexDirection: 'column',
    paddingBlock: '98px',
    [theme.breakpoints.down(DESKTOP_MIN_WIDTH)]: {
      paddingBlock: '60px',
    },
  };
});
